import { api } from './api-client.config';

export const getBlobsInContainer = async (prefix = '') => {
  try {
    const data: { files: { blobUrl: string; blobName: string }[] } =
      await api.get('/admin/files/list', {
        params: { prefix },
      });

    return data.files;
  } catch (error) {
    console.error('Error fetching files:', error);
    throw error;
  }
};

export const createBlobInContainer = async (file: File, prefix = '') => {
  try {
    const formData = new FormData();

    formData.append('files', file);
    formData.append('prefix', prefix);

    const data: { urls: string[] } = await api.post(
      '/admin/files/upload',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    return data.urls[0];
  } catch (error) {
    console.error('Error uploading file:', error);
    throw error;
  }
};

export const createBlobInContainerWithName = async (
  file: File,
  fileName: string
) => {
  try {
    const formData = new FormData();

    formData.append('file', file);
    formData.append('fileName', fileName);

    const data: { url: string } = await api.post(
      '/admin/files/upload-named',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    return data.url;
  } catch (error) {
    console.error('Error uploading file with name:', error);
    throw error;
  }
};

export const deleteBlobIfItExists = async (blobName: string) => {
  try {
    await api.delete(`/admin/files/${encodeURIComponent(blobName)}`);
    console.log(`deleted blob ${blobName}`);
  } catch (error) {
    console.error('Error deleting file:', error);
    throw error;
  }
};

export const isStorageConfigured = () => {
  return true;
};
